import React, { useState, useEffect, useRef } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const NavbarLogo = ({ className = "h-10 w-auto md:h-11" }) => (
  <svg viewBox="0 0 668 228" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} aria-hidden="true">
    <path fillRule="evenodd" clipRule="evenodd" d="M171.198 213.612V181.837H150.943V213.612C148.735 212.844 145.375 211.308 143.359 210.252C136.735 206.796 128.863 201.9 123.392 196.908L117.728 191.724C111.68 185.965 107.264 180.301 102.368 173.485C96.6085 165.421 91.1367 155.054 86.9129 144.59C81.0571 129.806 80.1931 122.511 80.1931 106.863V40.3375C80.1931 38.4176 80.0011 30.5458 80.4811 29.3939C81.2491 27.4739 84.609 25.266 86.4329 24.306C106.112 13.5544 135.391 10.0025 161.022 10.0025C185.694 10.0025 216.7 13.6504 235.516 24.21C243.58 28.7219 241.852 29.7778 241.852 39.9535V106.671C241.852 114.447 242.044 119.919 240.508 127.311C236.188 147.95 223.516 170.701 210.077 185.773C201.245 195.756 190.877 204.012 178.878 210.156C176.862 211.212 173.406 212.94 171.198 213.612ZM70.2094 118.863C71.1694 132.974 76.7372 146.894 81.921 158.222C88.1608 171.757 98.3365 186.541 107.936 196.236C109.088 197.388 110.048 198.348 111.2 199.5L117.92 205.548C120.704 207.948 125.792 211.692 128.863 213.612C137.023 218.699 145.567 222.827 155.263 225.707C161.214 227.531 160.35 227.531 165.246 226.187C171.774 224.459 178.206 221.867 183.774 218.987C195.773 212.94 204.029 206.412 213.149 197.292C222.94 187.501 228.124 179.533 235.036 168.013C238.204 162.829 240.892 156.782 243.388 150.926C245.979 145.07 248.187 138.254 249.819 131.63C251.835 123.183 252.027 117.423 252.027 108.303V31.5058C252.027 24.306 247.515 19.8902 241.756 16.2423C211.901 -2.47706 147.295 -3.34103 109.856 5.20268C96.8005 8.17858 81.5371 13.4584 74.5293 20.9461C72.7054 22.8661 70.4974 25.554 70.2094 29.3939C69.8255 33.3297 70.1134 38.2256 70.1134 42.2574V93.4237C70.1134 99.3755 69.8255 113.871 70.2094 118.863Z" fill="currentColor"/>
    <path fillRule="evenodd" clipRule="evenodd" d="M115.52 161.581H151.039C151.326 161.293 151.806 160.718 152.19 160.334L161.022 151.598L168.03 158.414C172.254 162.349 168.798 161.581 178.782 161.581C187.997 161.581 197.309 161.581 206.621 161.581C206.813 161.005 207.677 159.758 208.061 159.086L212.764 151.598C217.66 143.438 223.516 134.702 228.508 126.543C229.468 124.815 230.716 123.087 231.484 121.455L211.9 137.774C210.556 138.926 209.213 139.982 207.869 141.038L202.013 145.934C201.149 146.702 200.189 146.414 198.749 146.414C193.949 146.414 189.149 146.414 184.445 146.414C180.51 146.414 181.565 146.798 179.262 144.494L168.222 133.55C167.934 133.262 167.838 132.974 167.454 132.686C167.07 132.206 166.878 132.11 166.494 131.726C165.726 131.055 164.67 131.247 163.326 131.247C160.926 131.247 158.43 131.247 155.934 131.247C154.206 133.262 148.735 138.446 146.527 140.75C144.895 142.574 142.495 144.59 140.959 146.414C134.719 146.414 128.383 146.414 122.143 146.414C119.648 146.51 118.976 144.878 116.288 142.766C111.584 139.214 105.632 133.838 100.928 129.999C99.1043 128.559 97.4723 127.119 95.7444 125.679L90.5605 121.455C91.3285 123.087 92.5765 124.719 93.5364 126.351C98.3363 134.414 104.384 143.342 109.28 151.502L115.52 161.581Z" fill="currentColor"/>
    <path fillRule="evenodd" clipRule="evenodd" d="M231.58 65.3924C230.428 63.0885 228.028 59.8246 226.492 58.0007C220.252 50.6089 212.38 45.3291 201.245 45.4251C190.877 45.5211 182.333 51.3769 176.766 58.5767C175.806 59.7286 174.942 60.7846 173.982 62.0326C172.254 64.2405 169.854 66.9284 171.774 71.1522C174.366 76.9121 181.277 76.4321 184.061 73.6482C184.733 72.9762 185.885 70.9603 186.557 69.9043C193.277 59.7286 200.189 52.3369 214.876 56.8487C219.484 58.2887 223.708 60.4966 227.74 62.8965C228.892 63.6645 230.524 64.9125 231.58 65.3924Z" fill="currentColor"/>
    <path fillRule="evenodd" clipRule="evenodd" d="M90.5605 65.3927C91.6165 64.9127 93.0565 63.7607 94.3044 62.9927C111.872 52.0491 124.351 51.9531 135.487 69.7125C136.159 70.8645 137.311 72.7844 137.983 73.5524C142.495 78.5442 153.054 74.3204 150.655 65.9686C150.079 64.0487 146.815 60.4008 145.471 58.6729C139.711 51.3771 131.551 45.5213 120.896 45.4253C113.024 45.3293 106.784 48.0173 102.08 51.6651C97.9523 54.929 93.4404 60.1128 90.5605 65.3927Z" fill="currentColor"/>
    <path fillRule="evenodd" clipRule="evenodd" d="M95.457 83.2481C95.937 84.0161 96.513 84.3041 97.281 84.9761C104.961 91.3119 117.728 92.3678 127.136 88.72C129.056 88.048 134.528 85.1681 135.68 83.2481C134.528 81.4242 129.248 78.6403 127.328 77.8723C119.84 74.9924 111.488 74.9924 104.001 77.8723C101.985 78.6403 96.513 81.5202 95.457 83.2481Z" fill="currentColor"/>
    <path fillRule="evenodd" clipRule="evenodd" d="M186.462 83.2481C187.422 85.0721 192.798 87.952 194.814 88.72C203.645 92.0798 214.781 91.5039 222.749 86.416C223.421 86.0321 224.093 85.5521 224.669 85.0721C225.533 84.4961 226.205 84.0161 226.589 83.2481C225.533 81.4242 220.157 78.6403 218.237 77.8723C210.845 74.9924 202.397 74.9924 195.006 77.8723C192.894 78.6403 187.518 81.5202 186.462 83.2481Z" fill="currentColor"/>
    <path fillRule="evenodd" clipRule="evenodd" d="M41.2184 118.383C40.4504 117.039 40.0664 114.831 39.8744 113.391L40.9304 113.103C41.0264 113.007 41.6984 113.103 41.7944 113.103C42.4663 113.103 43.0423 113.199 43.7143 113.199L50.0501 113.391C50.9141 115.503 52.738 122.415 52.45 124.143C50.6261 124.335 43.7143 123.951 42.1784 123.471C41.6984 122.031 40.9304 119.823 41.2184 118.383ZM34.5946 91.2158C36.6105 90.6398 42.3703 91.4078 45.0583 91.4078L47.5542 101.871C46.1142 102.255 38.5305 101.775 36.9945 101.391L34.5946 91.2158ZM32.0027 79.3122C31.1387 76.9123 29.4108 71.0565 29.7948 68.9446L39.9704 69.3286L42.4663 79.7922C40.9304 80.2722 33.5386 79.7922 32.0027 79.3122ZM24.7069 48.4013C26.3389 47.8253 32.5787 48.8813 35.1706 48.4973L37.5705 59.3449L27.2029 58.8649L24.7069 48.4013ZM33.9226 125.391C42.5623 147.95 55.8099 148.046 60.4177 131.246C62.0497 125.007 61.6657 118.863 61.4737 111.375L59.9377 50.1292C59.3618 36.7857 59.7458 21.2342 66.1775 12.5945C59.7458 16.7223 56.2899 26.418 54.9459 33.2338C54.5619 35.4417 54.5619 39.4736 53.89 41.1055L18.9471 39.0896C15.3953 38.8976 10.6914 37.8416 7.23553 40.3375C-2.17215 47.0573 -0.6362 77.1043 2.05171 85.552L23.939 86.896C25.8589 91.8878 27.3949 100.816 28.7388 106.287C30.2748 112.623 31.6187 119.151 33.9226 125.391Z" fill="currentColor"/>
    <path fillRule="evenodd" clipRule="evenodd" d="M280.059 118.383C280.827 117.039 281.211 114.831 281.403 113.391L280.347 113.103C280.251 113.007 279.675 113.103 279.483 113.103C278.811 113.103 278.235 113.199 277.563 113.199L271.227 113.391C270.459 115.503 268.539 122.415 268.827 124.142C270.651 124.334 277.563 123.95 279.099 123.47C279.579 122.031 280.347 119.823 280.059 118.383ZM286.683 91.2156C284.667 90.6396 279.003 91.4076 276.219 91.4076L273.819 101.871C275.163 102.255 282.747 101.775 284.283 101.391L286.683 91.2156ZM289.274 79.312C290.138 76.9121 291.866 71.0563 291.482 68.9443L281.403 69.3283L278.907 79.792C280.443 80.272 287.835 79.792 289.274 79.312ZM296.57 48.401C294.938 47.825 288.698 48.881 286.107 48.497L283.707 59.3447L294.17 58.8647L296.57 48.401ZM287.355 125.39C278.715 147.95 265.467 148.046 260.955 131.246C259.227 125.006 259.611 118.863 259.803 111.375L261.339 50.129C261.915 36.7854 261.531 21.2339 255.1 12.5942C261.531 16.7221 264.987 26.4178 266.331 33.2335C266.715 35.4415 266.811 39.4733 267.387 41.1053L302.33 39.0893C305.882 38.8974 310.586 37.8414 314.042 40.3373C323.545 47.0571 321.913 77.1041 319.225 85.5518L297.434 86.8957C295.514 91.8876 293.882 100.815 292.538 106.287C291.002 112.623 289.754 119.151 287.355 125.39Z" fill="currentColor"/>
    <path fillRule="evenodd" clipRule="evenodd" d="M364.535 212.773H654.445C661.549 212.773 667.405 206.917 667.405 199.813V155.175C667.405 147.975 661.549 142.119 654.445 142.119H364.535C357.335 142.119 351.479 147.975 351.479 155.175V199.813C351.479 206.917 357.335 212.773 364.535 212.773ZM398.422 168.902H408.214V165.831C408.214 156.327 404.854 152.295 394.966 152.295C386.134 152.295 381.43 156.903 381.43 164.679C381.43 172.07 386.23 175.43 392.374 180.71C395.734 183.59 397.75 185.702 397.75 189.734C397.75 192.038 396.694 193.382 395.158 193.382C393.046 193.382 392.278 191.462 392.278 187.91V182.438H381.334V188.39C381.334 198.085 385.462 202.597 394.966 202.597C404.086 202.597 408.598 197.893 408.598 188.39C408.598 182.438 407.062 178.31 402.358 174.566C396.214 169.766 392.278 166.983 392.278 164.391C392.278 162.663 393.43 161.703 395.062 161.703C397.366 161.703 398.422 163.143 398.422 166.119V168.902ZM424.821 161.991H431.157V201.925H441.908V161.991H448.244V153.063H424.821V161.991ZM465.236 153.063V201.925H476.083V179.846H478.675L481.459 201.925H492.787L488.755 177.638C490.963 176.486 492.307 173.222 492.307 167.751C492.307 157.287 489.331 153.063 479.731 153.063H465.236ZM475.699 171.59V161.607H477.811C480.595 161.607 481.651 163.047 481.651 166.407C481.651 170.438 480.883 171.59 477.427 171.59H475.699ZM510.354 201.925H532.913V192.614H521.202V179.846H531.953V170.63H521.202V162.375H532.433V153.063H510.354V201.925ZM549.617 201.925H560.368V193.862H565.648V201.925H576.496V192.326C576.496 175.622 574.288 162.855 567.856 153.063H558.256C551.825 162.759 549.617 175.622 549.617 192.326V201.925ZM560.368 184.646C560.464 175.238 561.424 168.039 563.056 163.143C564.592 168.039 565.552 175.238 565.648 184.646H560.368ZM626.798 201.925H637.55V153.063H623.15C620.27 156.327 617.774 160.743 616.143 166.023C614.415 160.743 611.919 156.327 609.039 153.063H594.639V201.925H605.391V164.775C610.479 170.822 610.767 176.198 610.767 182.246V201.925H621.422V182.246C621.422 176.198 621.71 170.822 626.798 164.775V201.925ZM361.943 147.591H363.383C365.399 147.591 367.031 149.319 367.031 151.335V161.511C367.031 163.623 365.399 165.255 363.383 165.255H361.943C359.927 165.255 358.199 163.623 358.199 161.511V151.335C358.199 149.319 359.927 147.591 361.943 147.591ZM361.943 168.518H363.383C365.399 168.518 367.031 170.15 367.031 172.166V182.438C367.031 184.454 365.399 186.086 363.383 186.086H361.943C359.927 186.086 358.199 184.454 358.199 182.438V172.166C358.199 170.15 359.927 168.518 361.943 168.518ZM361.943 189.638H363.383C365.399 189.638 367.031 191.366 367.031 193.382V203.557C367.031 205.573 365.399 207.301 363.383 207.301H361.943C359.927 207.301 358.199 205.573 358.199 203.557V193.382C358.199 191.366 359.927 189.638 361.943 189.638ZM656.941 147.591H658.381C660.397 147.591 662.029 149.319 662.029 151.335V161.511C662.029 163.623 660.397 165.255 658.381 165.255H656.941C654.925 165.255 653.197 163.623 653.197 161.511V151.335C653.197 149.319 654.925 147.591 656.941 147.591ZM656.941 168.518H658.381C660.397 168.518 662.029 170.15 662.029 172.166V182.438C662.029 184.454 660.397 186.086 658.381 186.086H656.941C654.925 186.086 653.197 184.454 653.197 182.438V172.166C653.197 170.15 654.925 168.518 656.941 168.518ZM656.941 189.638H658.381C660.397 189.638 662.029 191.366 662.029 193.382V203.557C662.029 205.573 660.397 207.301 658.381 207.301H656.941C654.925 207.301 653.197 205.573 653.197 203.557V193.382C653.197 191.366 654.925 189.638 656.941 189.638Z" fill="currentColor"/>
    <g clipPath="url(#clip0_header_logo)">
      <path d="M351 14.5516H375.029V53.3805H386.169V14.5516H410.198V123.24H386.169V73.2723H375.029V123.24H351V14.5516ZM444.55 84.8892H454.894V38.4218C448.051 50.0386 444.55 64.3608 444.55 81.5473V84.8892ZM420.839 105.577C420.68 102.235 420.68 99.0522 420.68 95.7103C420.68 64.2016 427.841 38.1035 443.118 16.7795H478.127V84.8892H484.015V105.577H478.127V123.24H454.894V105.577H420.839ZM529.93 123.24C529.77 96.0286 528.656 79.1603 523.882 72.3175C521.973 74.2271 519.904 75.8185 517.835 77.569V123.24H494.283V14.5516H517.835V57.0406C524.042 50.516 529.293 35.3982 529.93 14.5516H553.959C553.959 16.1429 554.118 17.0978 554.118 17.5752C554.118 33.3295 550.14 47.1742 543.297 57.1997C548.389 63.8834 553.959 85.2074 553.959 115.92V123.24H529.93ZM566.857 14.5516H590.887V123.24H566.857V14.5516ZM605.216 49.5612C605.216 24.5771 612.059 13.1194 635.452 13.1194C657.413 13.1194 665.688 23.6223 665.688 47.3334V51.7891H641.34V43.9915C641.34 36.9896 641.022 33.8069 635.452 33.8069C629.882 33.8069 629.564 36.6713 629.564 43.1958V91.0954C629.564 99.6887 629.882 103.985 636.407 103.985C643.091 103.985 643.409 99.3704 643.409 90.1406V75.6593H637.043V57.8362H665.688V123.081H655.503L652.479 118.625C647.069 123.081 641.34 124.673 633.861 124.673C612.059 124.673 605.216 112.42 605.216 88.231V49.5612Z" fill="currentColor"/>
    </g>
    <defs>
      <clipPath id="clip0_header_logo">
        <rect width="315" height="112" fill="white" transform="translate(351 13.1194)"/>
      </clipPath>
    </defs>
  </svg>
);

const Header = () => {
  const { user, logout, isAuthenticated } = useAuth();
  const navigate = useNavigate();

  const [showMenu, setShowMenu] = useState(false);
  const [showSearch, setShowSearch] = useState(false);
  const [showNotifications, setShowNotifications] = useState(false);
  const [showMobileMenu, setShowMobileMenu] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");

  const menuRef = useRef(null);
  const searchRef = useRef(null);
  const notificationRef = useRef(null);
  const searchInputRef = useRef(null);
  const mobileMenuRef = useRef(null);

  const navLinkClass = ({ isActive }) =>
    `px-4 py-2 rounded-xl transition ${
      isActive
        ? "text-white bg-[#1A1A1A]"
        : "text-[#BFBFBF] hover:text-white hover:bg-[#1A1A1A]"
    }`;

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setShowMenu(false);
      }
      if (searchRef.current && !searchRef.current.contains(event.target)) {
        setShowSearch(false);
        setSearchQuery("");
      }
      if (notificationRef.current && !notificationRef.current.contains(event.target)) {
        setShowNotifications(false);
      }
      if (mobileMenuRef.current && !mobileMenuRef.current.contains(event.target)) {
        setShowMobileMenu(false);
      }
    };

    if (showMenu || showSearch || showNotifications || showMobileMenu) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showMenu, showSearch, showNotifications, showMobileMenu]);

  useEffect(() => {
    if (showSearch) {
      setTimeout(() => searchInputRef.current?.focus(), 0);
    }
  }, [showSearch]);

  const getSubscriptionNotifications = () => {
    if (!user || !user.subscription || !user.subscription.endDate) return [];

    const endDate = new Date(user.subscription.endDate);
    const now = new Date();
    const daysRemaining = Math.ceil((endDate - now) / (1000 * 60 * 60 * 24));

    const notifications = [];

    if (daysRemaining < 0) {
      notifications.push({
        id: "expired",
        message: "Votre abonnement a expiré. Veuillez renouveler pour continuer à regarder.",
        type: "error",
        link: "/subscriptions",
      });
    } else if (daysRemaining <= 3) {
      notifications.push({
        id: "3days",
        message: `Votre abonnement expire dans ${daysRemaining} jour${daysRemaining !== 1 ? "s" : ""}. Renouvelez maintenant !`,
        type: "warning",
        link: "/subscriptions",
      });
    } else if (daysRemaining <= 7) {
      notifications.push({
        id: "7days",
        message: `Votre abonnement expire dans ${daysRemaining} jours. Renouvelez bientôt !`,
        type: "info",
        link: "/subscriptions",
      });
    }

    return notifications;
  };

  const notifications = getSubscriptionNotifications();
  const hasNotifications = notifications.length > 0;

  const handleSearch = (e) => {
    e.preventDefault();
    if (searchQuery.trim()) {
      navigate(`/movies?search=${encodeURIComponent(searchQuery.trim())}`);
      setSearchQuery("");
      setShowSearch(false);
    }
  };

  const handleLogout = () => {
    logout();
    navigate("/");
    setShowMenu(false);
  };

  return (
    <header className="bg-[#141414] z-[9999] mt-8 md:mt-0">
      <div className="container mx-auto px-4 py-3 md:py-4 flex items-center justify-between">
        <Link to="/" className="flex items-center space-x-2 text-white">
          <NavbarLogo />
        </Link>

        {/* Desktop Navigation */}
        <nav
          className="hidden md:flex items-center space-x-4 border-2 rounded-xl border-[#1F1F1F] py-3 px-4"
        >
          <NavLink to="/" className={navLinkClass} end>
            Accueil
          </NavLink>

          <NavLink to="/movies" className={navLinkClass}>
            Films & Séries
          </NavLink>

          <NavLink to="/support" className={navLinkClass}>
            Support
          </NavLink>

          <NavLink to="/subscriptions" className={navLinkClass}>
            Abonnements
          </NavLink>
        </nav>

        <div className="flex items-center space-x-2 md:space-x-4">
          <div className="relative flex items-center" ref={searchRef}>
            {showSearch && (
              <div className="fixed inset-0 bg-black/50 z-[9999] md:hidden" onClick={() => {
                setShowSearch(false);
                setSearchQuery("");
              }} />
            )}
            
            {showSearch ? (
              <form
                onSubmit={handleSearch}
                className="relative flex items-center w-[calc(100vw-120px)] md:w-80 fixed md:relative top-16 md:top-auto left-4 md:left-auto z-[10000] md:z-auto"
              >
                <svg 
                  className="absolute left-3 w-5 h-5 text-white/60 pointer-events-none" 
                  fill="none" 
                  stroke="currentColor" 
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                  />
                </svg>
                <input
                  ref={searchInputRef}
                  type="text"
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  placeholder="Rechercher des films..."
                  className="w-full pl-10 pr-10 py-2 bg-[#1A1A1A] text-white rounded-xl border border-[#2A2A2A] focus:border-[#3A3A3A] focus:outline-none"
                  onKeyDown={(e) => {
                    if (e.key === "Escape") {
                      setShowSearch(false);
                      setSearchQuery("");
                    }
                  }}
                />
                <button
                  type="button"
                  onClick={() => {
                    setShowSearch(false);
                    setSearchQuery("");
                  }}
                  className="absolute right-3 text-white/60 hover:text-white transition"
                  aria-label="Close search"
                >
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </button>
              </form>
            ) : (
              <button
                type="button"
                onClick={() => setShowSearch(true)}
                className="text-white hover:text-gray-300 transition p-2 rounded-xl relative z-[10001]"
                aria-label="Search"
              >
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                  />
                </svg>
              </button>
            )}

          </div>

          {isAuthenticated && (
            <div className="relative z-10" ref={notificationRef}>
              <button
                onClick={() => setShowNotifications(!showNotifications)}
                className="text-white hover:text-gray-300 transition p-2 relative"
              >
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"
                  />
                </svg>
                {hasNotifications && (
                  <span className="absolute top-0 right-0 w-2 h-2 bg-red-500 rounded-full"></span>
                )}
              </button>

              {showNotifications && (
                <div className="absolute right-0 mt-2 w-80 bg-gray-800 rounded-lg shadow-lg py-2 z-50 max-h-96 overflow-y-auto">
                  {hasNotifications ? (
                    notifications.map((notification) => (
                      <Link
                        key={notification.id}
                        to={notification.link}
                        onClick={() => setShowNotifications(false)}
                        className={`block px-4 py-3 hover:bg-gray-700 transition ${
                          notification.type === "error"
                            ? "border-l-4 border-red-500"
                            : notification.type === "warning"
                            ? "border-l-4 border-yellow-500"
                            : "border-l-4 border-blue-500"
                        }`}
                      >
                        <div className="flex items-start space-x-2">
                          <div
                            className={`flex-shrink-0 mt-1 ${
                              notification.type === "error"
                                ? "text-red-400"
                                : notification.type === "warning"
                                ? "text-yellow-400"
                                : "text-blue-400"
                            }`}
                          >
                            {notification.type === "error"
                              ? "⚠️"
                              : notification.type === "warning"
                              ? "⚠️"
                              : "ℹ️"}
                          </div>
                          <div className="flex-1">
                            <p className="text-white text-sm">{notification.message}</p>
                            <p className="text-gray-400 text-xs mt-1">Cliquez pour renouveler</p>
                          </div>
                        </div>
                      </Link>
                    ))
                  ) : (
                    <div className="px-4 py-3 text-gray-400 text-sm text-center">
                      Aucune notification
                    </div>
                  )}
                </div>
              )}
            </div>
          )}

          {isAuthenticated ? (
            <div className="relative z-10" ref={menuRef}>
              <button
                onClick={() => setShowMenu(!showMenu)}
                className="text-white hover:text-gray-300 transition p-2"
              >
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
                  />
                </svg>
              </button>

              {showMenu && (
                <div className="absolute right-0 mt-2 w-48 bg-gray-800 rounded-lg shadow-lg py-2 z-50">
                  <Link
                    to="/profile"
                    className="block px-4 py-2 text-white hover:bg-gray-700 transition"
                    onClick={() => setShowMenu(false)}
                  >
                    Profil
                  </Link>

                  {user?.role === "admin" && (
                    <Link
                      to="/admin"
                      className="block px-4 py-2 text-white hover:bg-gray-700 transition"
                      onClick={() => setShowMenu(false)}
                    >
                      Admin
                    </Link>
                  )}

                  <button
                    onClick={handleLogout}
                    className="block w-full text-left px-4 py-2 text-white hover:bg-gray-700 transition"
                  >
                    Déconnexion
                  </button>
                </div>
              )}
            </div>
          ) : (
            <Link
              to="/login"
              className="px-4 py-2 rounded-full bg-white text-black z-10 relative"
            >
              Connexion
            </Link>
          )}

          {/* Burger Menu Button - Mobile Only - After User Icon */}
          <button
            onClick={() => setShowMobileMenu(!showMobileMenu)}
            className="md:hidden text-white hover:text-gray-300 transition p-2 relative z-10"
            aria-label="Menu"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              {showMobileMenu ? (
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              ) : (
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
              )}
            </svg>
          </button>
        </div>
      </div>

      {/* Mobile Menu Overlay */}
      {showMobileMenu && (
        <>
          <div 
            className="fixed inset-0 bg-black/50 z-[9998] md:hidden"
            onClick={() => setShowMobileMenu(false)}
          />
          <div 
            ref={mobileMenuRef}
            className="fixed top-0 left-0 h-full w-64 bg-[#1A1A1A] z-[9999] md:hidden transform transition-transform duration-300 ease-out shadow-xl"
          >
            <div className="flex flex-col p-6 space-y-2">
              <div className="flex items-center justify-between mb-6 text-white">
                <NavbarLogo className="h-8 w-auto" />
                <button
                  onClick={() => setShowMobileMenu(false)}
                  className="text-white hover:text-gray-300 transition"
                >
                  <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </button>
              </div>

              <NavLink 
                to="/" 
                className={({ isActive }) => 
                  `px-4 py-3 rounded-xl transition ${
                    isActive 
                      ? "text-white bg-[#262626]" 
                      : "text-[#BFBFBF] hover:text-white hover:bg-[#262626]"
                  }`
                }
                onClick={() => setShowMobileMenu(false)}
                end
              >
                Accueil
              </NavLink>

              <NavLink 
                to="/movies" 
                className={({ isActive }) => 
                  `px-4 py-3 rounded-xl transition ${
                    isActive 
                      ? "text-white bg-[#262626]" 
                      : "text-[#BFBFBF] hover:text-white hover:bg-[#262626]"
                  }`
                }
                onClick={() => setShowMobileMenu(false)}
              >
                Films & Séries
              </NavLink>

              <NavLink 
                to="/support" 
                className={({ isActive }) => 
                  `px-4 py-3 rounded-xl transition ${
                    isActive 
                      ? "text-white bg-[#262626]" 
                      : "text-[#BFBFBF] hover:text-white hover:bg-[#262626]"
                  }`
                }
                onClick={() => setShowMobileMenu(false)}
              >
                Support
              </NavLink>

              <NavLink 
                to="/subscriptions" 
                className={({ isActive }) => 
                  `px-4 py-3 rounded-xl transition ${
                    isActive 
                      ? "text-white bg-[#262626]" 
                      : "text-[#BFBFBF] hover:text-white hover:bg-[#262626]"
                  }`
                }
                onClick={() => setShowMobileMenu(false)}
              >
                Abonnements
              </NavLink>
            </div>
          </div>
        </>
      )}
    </header>
  );
};

export default Header;
